import { render, staticRenderFns } from "./zlyhj.vue?vue&type=template&id=119202f5&scoped=true"
import script from "./zlyhj.vue?vue&type=script&lang=js"
export * from "./zlyhj.vue?vue&type=script&lang=js"
import style0 from "./zlyhj.vue?vue&type=style&index=0&id=119202f5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119202f5",
  null
  
)

export default component.exports